import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixed'
})
export class ToFixedPipe implements PipeTransform {
  transform(value: any, digits: number = 3, keepTrailingZeros: boolean = false): any {
    if (value === null || value === undefined || value === '') return value;
    const num = Number(value);
    if (!isFinite(num)) return value;
    return keepTrailingZeros ? num.toFixed(digits) : parseFloat(num.toFixed(digits));
  }
}
